<div class="skeleton-row"></div>
